var _circle, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIlmcv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "#166C7E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5,
    width: 20.5263,
    height: 20,
    fill: "url(#pattern0_116_3864)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_116_3864",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_116_3864",
    transform: "matrix(0.02 0 0 0.0205263 0 -0.0131578)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_116_3864",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOGSURBVHgB7VndcZtAEN5DeY8aiAUdOBWEDqxUYLsC2xXYqcB2BcYVxK4guIKoAyFVoDxn4PItBzJ/xx2ykFBG34yGE7d3sLf/C9ERRxzRBkF7xFzOxyNy7jH0m+YlyZUgMYspufGEt2rb6xPtEQ45D7ic6+aFOudTh2iB613LVu+M4HRcnM4tzsGlHhGTvMTpRjzGa45t1ghyJiaaNSMjEk+UirhfbcNzfuPQPFYVqEyAwzszLIF6Jc8GmndGJJG3I4MZZ78VmHlhpkYaG2HERC8m+2CsGWGjwsUowm0jU7OAPoiCRJKZMIt561jK+QXM/ptuHu/1JyF6yO1KhzUjIJ6NaLdYyMU1LvdtNIJ9G9EZVPBrm4o5hXFIO4YgaaUBsF0XL3rRRrNmhLlFAFrQYOFctc6W/8qQ9goRwiaepXK3r6UZSAXq5etWViM7ey5tpO0f8fNEeEH+bymXv3C4fv5/RCME7GYTKElktAc7aUdcCYTS10mlxMhfoggXY/DZFU6UdErvk0mlhhIjyuBTZgYD2Mtj5Q5Lxa3SOfWlyRsNCBwMqSIVvPR1la7GiFAGPxgoLSlLBUHynGuZ4r0aI/HgDL5RKuOqVGqMZDnNYAyekUml5MEglauiVBzN2r7tpPNBZVIpoiSVRkZQ8DBBRNsHe8Ubm/qiCqUpIizeY1vJx5/0i8ijgSGm+BEVpd8059BhQSvJmkRUE4Lrd+FS/7BqPtigxkjGhE8HhppqyQHahg0OzUa0MHYaOT0Aty/UAxK0S5ESndIWYGSEc68vwgupByxltNpWQ7Bz75cLG0hoimD0OWvVzLxCVfdRbLq/NSN4wCmC0U8M3fwet2q4hYS2zm2iOuYfVEHnqdiSqux/2bayJteFjCJ0HQsdR04LZITBlIx+X4IR0SX98KlwMGZwc6QUGqITMUm9rIVEpE/WEFPqFfr49t+43wZGZECHgzAfNPo+bizLrNUvVIPZJXtwEfRqS5w1zq1zLtUcSfsKM3i0IC8JjE58IedBMe+3eNTbiXB9W+pt7W+0EdGxhkf/uGvzohO9TD1jHUZGYpWeWLvUhpLURB903H8zRrJvfd/JAtDfH6YPMpr9b2xoszI5apqzcr9YHGbMRBqStBafiMkdbQBOQXi9xf5aaXfK2FT1mH75Za/mYnEkEfmRPgRdJaHbX+VZYlrZ/2GThsURRxzxjn/hZEESjkLzuwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlmcv);
export default __webpack_public_path__ + "static/media/ILMCV.f9bd346002b8a96cf2b34657c0c5ce1e.svg";
export { ForwardRef as ReactComponent };